import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'not-found',
  imports: [],
  standalone: true,
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent {
  title = input<string>('¡STOP INESPERADO!')
  description = input<string>('Parece que no encontramos nada por aquí. Revisa tu búsqueda y sigue la carrera')
}
